import React from 'react';
import DefaultThumbnailImage from '@components/images/DefaultThumbnailImage';
import {
  StyledCardAnchorContainer,
  StyledImageContainer,
  StyledTitleContainer,
  StyledTitle,
  StyledCardLinkContainer,
} from './styles';
import type { MediumCardProps } from './types';
import CardContent from '../CardContent';
import BookCardContent from '@components/cards/BookCardContent';
import CustomLink from './CustomLink';

const MediumCard: React.FC<MediumCardProps> = ({
  cardType,
  actionType,
  to = `/`,
  href = `#`,
  tagText,
  title,
  author,
  isbn,
  publisher,
  dateOfPublication,
  category,
  description,
  image,
}) => {
  const actionTypeSafe: 'button' | 'link' | 'anchor' | 'internal' | 'external' =
    actionType as 'button' | 'link' | 'anchor' | 'internal' | 'external';
  const cardTypeSafe: 'resource' | 'pastEvent' | string =
    cardType ?? 'resource';

  const renderCardContent = () => (
    <CardContent
      actionType={actionTypeSafe} // Ensure it's one of the allowed types
      cardType={cardTypeSafe} // Ensure it matches the expected type
      tagText={tagText}
      title={title}
      description={description}
      charLimitTitle={40}
      charLimitDesc={82}
    />
  );

  const renderImage = () => (
    <StyledImageContainer>
      {image || <DefaultThumbnailImage height={134} width={282} />}
    </StyledImageContainer>
  );

  const renderAnchorContainer = () => (
    <StyledCardAnchorContainer
      href={href}
      target="_blank"
      rel="noopener noreferrer"
    >
      {renderImage()}
      {renderCardContent()}
    </StyledCardAnchorContainer>
  );

  const renderLinkContainer = () => {
    if (!to) {
      console.error("Missing 'to' prop for CustomLink");
      return null; // Or handle the case where 'to' is undefined
    }

    return (
      <CustomLink href={to}>
        {renderImage()}
        {renderCardContent()}
      </CustomLink>
    );
  };

  // if past event pass new url for single page
  const eventUrl = `/events/${to}`;

  switch (cardType) {
    case 'home':
      return actionType === 'anchor' || actionType === 'external'
        ? renderAnchorContainer()
        : renderLinkContainer();
    case 'resource':
      return renderAnchorContainer();
    case 'books':
      return (
        <StyledCardLinkContainer
          href={to}
          style={{
            minHeight: 'fit-content',
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <StyledTitleContainer
            style={{
              backgroundColor: 'white',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-start',
              flexWrap: 'wrap',
              paddingLeft: '10px',
            }}
          >
            <StyledTitle>{title}</StyledTitle>
          </StyledTitleContainer>
          <BookCardContent
            // actionType="link"
            cardType={cardType}
            // tagText={genre}
            // title={title}
            author={author}
            isbn={isbn}
            publisher={publisher}
            dateOfPublication={dateOfPublication}
            category={category}
            // description={description}
            charLimitTitle={40}
            charLimitDesc={82}
          />
        </StyledCardLinkContainer>
      );
    case 'pastEvent':
    default:
      return <CustomLink href={eventUrl}>{renderCardContent()}</CustomLink>;
  }
};

export default MediumCard;
